import { initialize } from 'launchdarkly-js-client-sdk';

import defaultToggles from 'app/config/ld_toggle_defaults.json';
import jwt_decode from 'jwt-decode';
import Config from './Config';
import Debug from './Debug';
import Session from './Session';

const LD_TIMEOUT = 5000;
let _ld = null;

let toggleCache = {};
// Returns the feature flag
const ft = (flag, defaultValue) => {
  if (!_ld) {
    return false;
  }
  if (flag in toggleCache) {
    return toggleCache[flag];
  }
  const toggleValue = _ld.variation(flag, defaultValue || false);
  toggleCache[flag] = toggleValue;
  return toggleValue;
};

// Returns LDClient handle
const ldClient = () => {
  return _ld;
};

const init = () => {
  let context;
  if (Session.getToken()) {
    let decodedToken = jwt_decode(Session.getToken());
    let userDetailsOc = JSON.parse(localStorage.getItem('user_details_oc')) || {};

    let _key = decodedToken.user || userDetailsOc.userId;
    let _email = decodedToken.email || userDetailsOc.email;
    let _tenantId = decodedToken.tenant || userDetailsOc.tenantId;
    context = {
      kind: 'user',
      ...(_key ? { key: _key } : {}),
      ...(_email ? { email: _email } : {}),
      ...(_tenantId ? { custom: { tenantId: _tenantId } } : {}),
    };
  } else {
    context = {
      kind: 'user',
      anonymous: true,
    };
  }

  return new Promise((resolve, reject) => {
    let ldTimedOut = false;
    let ldTimeout = setTimeout(() => {
      Debug.log('No response from LaunchDarkly service');
      ldTimedOut = true;
      reject();
    }, LD_TIMEOUT);
    const _onError = (err) => {
      Debug.log('LD intitialized with context : ');
      Debug.log(err);
      // To Update defaultToggles - trigger DaasUi._ld.allFlags() in console and copy paste the output in file: (app/config/ld_toggle_defaults.json)
      // Ideally the defaults should be taken from a prod account.
      toggleCache = { ...toggleCache, ...defaultToggles };
    };
    _ld = initialize(Config.get('ldEnvironmentId'), context);
    _ld.on('ready', () => {
      if (ldTimedOut) {
        Debug.log('Response from LaunchDarkly service after timeout expired');
      } else {
        clearTimeout(ldTimeout);
        resolve();
        toggleCache = {};
      }
      window.GLDClient = ldClient();
    });
    _ld.on('error', _onError);
  });
};

export { init, ft as default, ldClient };
